export default __webpack_public_path__ + "static/media/tipo_compra_producto.a185e6fe.svg";